import authInstance from "../utilities/axios/authInstance";

export const allUsers = () => authInstance.get('users');

export const oneUser = (id) => authInstance.get('users/' + id);

export const addUser = (user) => authInstance.post('users', user);

export const updateUser = (id, user) => authInstance.put('users/' + id, user);

export const removeUser = (id) => authInstance.delete('users/' + id);

export const searchOfficers = (officer) => authInstance.get('search/users', {
    params: {
        name: officer
    }
});

export const searchSupervisors = (supervisor) => authInstance.get('search/supervisors', {
    params: {
        name: supervisor
    }
});